import productsMapping from './mock/products.json'
import type {
  GenderSwitchItem,
  GenderSwitchMapping,
  GenderSwitchProduct,
  GenderSwitchResolvedData,
} from './types'

const mapping = productsMapping as GenderSwitchMapping

const isRenderableProduct = (
  value: GenderSwitchProduct | null
): value is GenderSwitchProduct => {
  return (
    Boolean(value?.productId) &&
    Boolean(value?.productUrl) &&
    value?.status === 'active'
  )
}

export const resolveGenderSwitchByProductId = (
  currentProductId: string | null | undefined,
  items: GenderSwitchItem[]
): GenderSwitchResolvedData | null => {
  if (!currentProductId) {
    return null
  }

  const matchedItem = items.find(
    (item) =>
      item.male?.productId === currentProductId ||
      item.female?.productId === currentProductId
  )

  if (!matchedItem) {
    return null
  }

  if (
    !isRenderableProduct(matchedItem.male) ||
    !isRenderableProduct(matchedItem.female)
  ) {
    return null
  }

  const isMaleSelected = matchedItem.male.productId === currentProductId

  return {
    currentProductId,
    selectedGender: isMaleSelected ? 'men' : 'women',
    targetGender: isMaleSelected ? 'women' : 'men',
    male: matchedItem.male,
    female: matchedItem.female,
    targetProduct: isMaleSelected ? matchedItem.female : matchedItem.male,
  }
}

export const resolveGenderSwitchFromMock = (
  currentProductId: string | null | undefined
) => resolveGenderSwitchByProductId(currentProductId, mapping.items)
